


























































































import { Component, Vue } from 'vue-property-decorator'
import { OptionItemType } from '../../types/type'
import { CommonModule } from '../../store'
import { getNameTextInOptions } from '../../utils/toolsForCommon'
import { encode } from 'js-base64'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
@Component({
  name: 'CanteenIndexConfigDetail',
  components: {
    'concise-card': () => import('../../components/common/conciseCard.vue'),
    'loading-container': () => import('../../components/loading.vue'),
    'empty-container': () => import('../../components/empty.vue')
  }
})
export default class CanteenIndexConfigDetail extends Vue {
  public loading: boolean = false
  public detailInfo: any = {}
  // 类型选择：
  public moduleTypeOptionsForSM: any[] = []
  // 枚举选项：
  public indexConfigFileTypeOptions: OptionItemType[] = [
    {
      name: '通知公告',
      value: 'INFORM_ANNOUNCEMENT'
    },
    {
      name: '政策文件',
      value: 'POLICY_FILE'
    }
  ]
  // 附件数组
  public adjunctInfoList: Array<any> = []
  // 下载附件相关：
  public downloadForAllFileBtnText: string = "<span class='el-icon-download'></span>一键下载所有附件"
  public downloadForAllFileFlag: boolean = false
  // 展示此公告或者政策文件的接收人员和已读人员:
  public withUserContainerForAllUserList: Array<any> = []
  public withUserContainerForReadUserList: Array<any> = []

  get indexConfigFileTypeText (): string {
    const { type } = this.detailInfo
    return getNameTextInOptions(this.indexConfigFileTypeOptions, type)
  }

  get indexConfigFileTypeIcon (): string {
    let indexConfigFileTypeIcon = ''
    const { type } = this.detailInfo
    switch (type) {
      case 'INFORM_ANNOUNCEMENT':
        indexConfigFileTypeIcon = 'icon-gonggao'
        break
      case 'POLICY_FILE':
        indexConfigFileTypeIcon = 'icon-zhengce'
        break
    }
    return indexConfigFileTypeIcon
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get withUserContainerForAllUserBody () {
    if (!this.withUserContainerForAllUserList.length) return '- -'
    return this.withUserContainerForAllUserList.map(item => item.username).join('、')
  }

  get withUserContainerForReadUserBody () {
    if (!this.withUserContainerForReadUserList.length) return '- -'
    return this.withUserContainerForReadUserList.map(item => item.userName).join('、')
  }

  async mounted () {
    await CommonModule.getTreeDataForOrganization()
    const { id } = this.$route.query
    if (!id) return this.$router.go(-1)
    this.getDetail(id)
    this.newAnnouncementSelectReadUser(id)
  }

  // 根据id拿详情：
  async getDetail (id) {
    try {
      this.loading = true
      const { data: result } = await (this as any).$http.newAnnouncementGetById({
        id,
        loginUserType: 0
      })
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.detailInfo = result.data || {}
      this.detailInfo['textDetail'] = this.detailInfo.textDetail.replace(/<img/g, '<img style="width: 100%; display: block"')
      this.adjunctInfoList = JSON.parse(this.detailInfo.otherInfo || '[]').map(item => {
        item['previewUrl'] = (this as any).$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(item.url))
        item['iframeShowFlag'] = true
        return item
      })
      const sendArray = JSON.parse(this.detailInfo.sendArray || '[]')
      // 原本的循环请求：
      // for (let i = 0, len = sendArray.length; i < len; i++) {
      //   const userRes = await this.getSysUserInfo(sendArray[i])
      //   this.withUserContainerForAllUserList.push(userRes)
      // }
      // 新增的接口：
      const { data: resultForUsers } = await (this as any).$http.sysUserSelectListByIds(sendArray)
      // if (resultForUsers.code !== 200) return this.$message.error(resultForUsers.msg)
      this.withUserContainerForAllUserList = resultForUsers.data || []
    } catch (err) {
      console.log(err)
    }
  }

  // 附件是否需要等待：
  // loadingOfIframe (isRehresh?: string) {
  //   setTimeout(() => {
  //     this.adjunctInfoList = this.adjunctInfoList.map((item: any, index: number) => {
  //       let iframeBox = document.querySelector('#iframeBox' + index)
  //       if ((iframeBox as any).attachEvent) {
  //         ;(iframeBox as any).attachEvent('onload', function () {
  //           item.iframeShowFlag = true
  //         })
  //       } else {
  //         ;(iframeBox as any).onload = function () {
  //           item.iframeShowFlag = true
  //         }
  //       }
  //       return item
  //     })
  //     if (isRehresh) {
  //       let res = false
  //       setTimeout(() => {
  //         res = this.adjunctInfoList.some(item => {
  //           if (item.iframeShowFlag === false) return true
  //         })
  //         res ? this.$message.warning('抱歉，刷新失败') : this.$message.success('刷新成功')
  //       }, 100)
  //     }
  //   }, 100)
  // }

  async downloadForAllFile () {
    if (this.downloadForAllFileFlag) return this.$message.warning(`请勿重复操作`)
    if (!this.adjunctInfoList.length) return this.$message.warning(`暂无附件`)
    this.downloadForAllFileFlag = true
    this.downloadForAllFileBtnText = "<span class='el-icon-loading'></span>正在下载中，请稍后"
    await Promise.all(
      this.adjunctInfoList.map(item => {
        return this.download(item)
      })
    )
    this.$message.success(`附件已全部下载成功`)
    this.downloadForAllFileFlag = false
    this.downloadForAllFileBtnText = "<span class='el-icon-download'></span>一键下载所有附件"
  }

  download (item) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest()
      xhr.open('get', item.url, true)
      xhr.responseType = 'blob'
      xhr.onload = function () {
        if (this.status == 200) {
          var blob = this.response // 得到blob对象
          let oFileReader = new FileReader()
          oFileReader.readAsDataURL(blob)
          let src = window.URL.createObjectURL(blob)
          var eleLink = document.createElement('a')
          eleLink.href = src // 转换后的地址
          eleLink.download = item.name
          document.body.appendChild(eleLink)
          eleLink.click()
          document.body.removeChild(eleLink)
          resolve(true)
        }
      }
      xhr.send()
    })
  }

  // 查询已经看过公告或者政策文件的用户：
  async newAnnouncementSelectReadUser (id) {
    try {
      const { data: result } = await (this as any).$http.newAnnouncementSelectReadUser({
        id,
        loginType: 0
      })
      // if (result.code !== 200) return this.$message.error(result.msg)
      if (result.code !== 200) return
      ;(result.data || []).map(item => {
        (item.readUserList || []).forEach(v => {
          this.withUserContainerForReadUserList.push(v)
        })
      })
      // console.log(this.withUserContainerForReadUserList, 'withUserContainerForReadUserList')
    } catch (err) {
      console.log(err)
    }
  }

  // 根据用户id获取用户详情：
  async getSysUserInfo (id) {
    return new Promise(async (resolve, reject) => {
      try {
        let { data: result } = await (this as any).$http.getSysUserInfo({ id })
        // if (result.code !== 200) return this.$message.error(result.msg)
        if (result.code !== 200) return reject(result.msg)
        resolve(result.data)
      } catch (err) {
        reject(err)
      }
    })
  }
}
